import * as React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from 'components/ErrorMessage';

const FormItemWrapper = React.forwardRef(({ InputComponent, className, error, label, disabled, required, ...props }, ref) => (
  <div className={`flex flex-col ${className}`}>
    <div className={`flex flex-col gap-2${disabled ? ' cursor-not-allowed' : ''}`}>
      {label && <span className='text-base font-medium text-zinc-900'>
        {label}
        {required && <span className='text-red-500'> *</span>}
      </span>}
      <InputComponent
        ref={ref}
        disabled={disabled}
        {...props}
      />
    </div>
    <ErrorMessage className='mt-2'>
      {error?.message}
    </ErrorMessage>
  </div>
));

FormItemWrapper.propTypes = {
  InputComponent: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  disabled: PropTypes.bool,
  required: PropTypes.bool
};

FormItemWrapper.defaultProps = {
  className: "",
  label: null,
  error: null,
  disabled: false,
  required: false
}

export default FormItemWrapper;